import Tool, { type ToolArgsWithController } from '../../../tools/Tool';
import aiIconSvg from '../../../assets/icons/aiIcon.svg';
import { Range } from 'slate';

class ToolWritingAssistantSelection extends Tool {
  static toolName = 'AI assistant';
  static iconSvg = aiIconSvg;

  static available({ controller, editor }: ToolArgsWithController): boolean {
    if (!editor?.selection) return false;

    const { selection } = editor;
    return (
      controller.ahaEditor.hasProvider('assistant') &&
      controller.ahaEditor.hasProvider('fullScreen') &&
      Range.isExpanded(selection)
    );
  }

  static async action({ controller }: ToolArgsWithController) {
    const provider = controller.ahaEditor.getProvider('assistant');
    provider?.openWritingAssistant();
  }
}

export default ToolWritingAssistantSelection;
